import React, { useState } from 'react';
import { FileText, Scale, PenLine } from 'lucide-react';
import { DateField } from '../DateField';
import { fmtDate } from '../../lib/dates';

const TONE = {
  vencido: 'border-slate-600 text-slate-400', sin_fecha: 'border-purple-500/50 text-purple-300', urgente: 'border-red-500/60 text-red-300',
  proximo: 'border-amber-500/60 text-amber-300', vigente: 'border-emerald-500/50 text-emerald-300',
};
const LABEL = (d) => (d.status === 'sin_fecha' ? 'Falta fecha de notificación' : d.days_left < 0 ? `Venció hace ${-d.days_left} día(s)` : d.days_left === 0 ? 'Vence hoy' : `Faltan ${d.days_left} día(s)`);

export const DeadlineRow = ({ d, showMatter = false, onSetNotification, onDraft }) => {
  const [n, setN] = useState('');
  return (
  <div data-testid={`deadline-row-${d.id}`} className={`rounded-xl border bg-slate-900/70 p-3 ${TONE[d.status]}`}>
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1 sm:gap-3">
      <div className="min-w-0">
        <p className="text-white font-semibold text-sm">{d.title}</p>
        {showMatter && <p className="text-xs text-slate-400 truncate">{d.matter_title}{d.court ? ` · ${d.court}` : ''}</p>}
        <p className="text-xs text-slate-500 flex items-center gap-1 mt-0.5">
          {d.source === 'ley' ? <Scale className="w-3 h-3" /> : <FileText className="w-3 h-3" />}
          {d.source === 'ley' ? 'Calculado según la ley' : 'Detectado en documento'}{d.legal_basis ? ` · ${d.legal_basis}` : ''}
        </p>
        {d.detail && <p className="text-xs text-slate-500">{d.detail}</p>}
        {d.note && <p data-testid={`deadline-note-${d.id}`} className="text-[11px] text-amber-200/80">{d.note}</p>}
      </div>
      <div className="sm:text-right shrink-0">
        {d.due_date && <p className="text-sm font-bold text-white">{fmtDate(d.due_date)}</p>}
        <p className="text-xs">{LABEL(d)}</p>
        {onDraft && d.status !== 'vencido' && (
          <button data-testid={`deadline-draft-btn-${d.id}`} onClick={() => onDraft(d)} className="mt-1.5 text-xs bg-blue-600 hover:bg-blue-500 text-white rounded-full px-3 py-1 inline-flex items-center gap-1">
            <PenLine className="w-3 h-3" />Redactar escrito
          </button>
        )}
      </div>
    </div>
    {d.status === 'sin_fecha' && onSetNotification && (
      <div className="flex gap-2 mt-2">
        <DateField testid={`deadline-notif-date-${d.id}`} value={n} onChange={setN} className="py-1 text-xs" />
        <button data-testid={`deadline-notif-save-${d.id}`} disabled={!n} onClick={() => onSetNotification(d, n)} className="text-xs bg-purple-600 text-white rounded-lg px-3 py-1 disabled:opacity-40">Calcular vencimiento</button>
      </div>
    )}
  </div>
  );
};
